import { render, staticRenderFns } from "./EchartsProvinceStatistics.vue?vue&type=template&id=183cff74&"
import script from "./EchartsProvinceStatistics.vue?vue&type=script&lang=js&"
export * from "./EchartsProvinceStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports